<template>
  <div>
    <yxt-drawer
      ref="selectUser"
      :visible.sync="drawerVisible"
      size="960px"
      :before-close="beforeDrawClose"
      append-to-body
      :title="$t('pc_gwnl_eval_btn_addTesters'/* 添加测评人员 */)"
      class="talent-select-thirdparty-user"
    >
      <div class="display-flex gwnl-select__drawer col-flex-1">
        <div class="talent-select-thirdparty-user__left pt24">
          <div class="display-flex">
            <yxtbiz-eval-select-departmenttree @change="selectDept" :dataPermissionCode="dataPermissionCode" :functionCode="functionCode"/>
            <yxt-input
              v-model="keyword"
              class="ml12"
              style="width: 240px;"
              :placeholder="$t('pc_gwnl_jq_enterStudentNameAccount')"
              searchable
              size="small"
              @keyup.enter.native="search()"
              @search="search()"
            />
          </div>
          <div class="mt16 flex-1 overflow-auto">
            <yxt-table
              ref="table"
              v-loading="loading"
              :data="list"
              row-key="userId"
              @select="handleSelectionChange"
              @select-all="handleSelectAll"
            >
              <yxt-table-column
                prop="userId"
                reserve-selection
                type="selection"
                width="55"
                :selectable="(row) => row.selectable"
              />
              <yxt-table-column
                min-width="100"
                prop="fullName"
                :label="$t('pc_gwnl_global_lbl_name')"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <yxtbiz-user-name :name="scope.row.fullName" />({{ scope.row.userName }})
                </template>
              </yxt-table-column>
              <yxt-table-column
                :label="$t('pc_gwnl_eval_jobNumber')"
                prop="userNo"
              >
                <template slot-scope="scope">
                  {{ scope.row.userNo || '--' }}
                </template>
              </yxt-table-column>
              <yxt-table-column
                v-if="showModel"
                :label="$t('pc_gwnl_model_name')"
                prop="modelName"
              >
                <template slot-scope="scope">
                  {{ scope.row.modelName || '--' }}
                </template>
              </yxt-table-column>
            </yxt-table>
          </div>
          <div class="display-flex align-items-center justify-between mb4">
            <yxt-button
            v-if="supportSearchAll"
            type="text"
            class="lh32"
            :disabled="list.length === 0"
            @click="searchAll"
            >{{$t('biz_udp_all_filter_results')}}</yxt-button>
            <div class="clearfix">
              <yxtbiz-eval-pager
                :total.sync="pager.total"
                :page.sync="pager.offset"
                :limit.sync="pager.pageSize"
                layout="total, prev, pager, next"
                @pagination="getUserList"
              >
              </yxtbiz-eval-pager>
            </div>
          </div>
        </div>
        <div class="talent-select-thirdparty-user__right">
          <yxt-button
            v-if="!selectedList.length"
            class=""
            type="text"
            disabled
          >
            {{ `${$t('pc_gwnl_global_please_selected')}...` }}
          </yxt-button>
          <div
            v-else
            style="height: 100%; overflow: hidden;"
          >
            <yxt-scrollbar :fit-height="true">
              <div>
                <yxt-tag
                  v-for="(item, index) in selectedList"
                  :key="index"
                  class="mb10 mr5"
                  type="info"
                  size="mini"
                  closable
                  @close="handleSelectionClose(item)"
                >
                  <yxtbiz-user-name :name="item.fullName || '--'" />
                </yxt-tag>
              </div>
            </yxt-scrollbar>
              <yxt-button
              class="result-list__select-clear"
              type="text"
              :disabled="!selectedList.length"
              @click="clearAllSelection"
            >
              {{ $t('pc_gwnl_global_clearAll') }}
            </yxt-button>
            <div class="result-list__selected color-gray-8 standard-size-12" v-if="selectedList.length">
             {{ $t('pc_gwnl_eval_personCountSelected', { count: selectedList.length }) }}
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <yxt-button
          plain
          @click="cancel"
        >
          {{ $t("pc_gwnl_global_btn_cancel") }}
        </yxt-button>
        <yxt-button
          type="primary"
          @click="submit"
        >
          {{ $t("pc_gwnl_global_btn_next" /* 下一步 */) }}
        </yxt-button>
      </div>
    </yxt-drawer>
  </div>
</template>

<script>
// import {GetEvalPositionUsers} from '../../eval-create-drawer/src/service';
import evalPager from '../../eval-pager';
import evalSelectDepartmenttree from './components/eval-select-departmenttree';

export default {
  name: 'YxtbizEvalSelectThirdpartyUser',
  components: {
    yxtbizEvalPager: evalPager,
    yxtbizEvalSelectDepartmenttree: evalSelectDepartmenttree
  },
  props: {
    showModel: {
      type: Boolean,
      default: false
    },
    defaultSelection: {
      type: Array,
      default: () => ([])
    },
    defaultRaw: {
      type: Array,
      default: () => ([])
    },
    visible: {
      type: Boolean,
      default: false
    },
    getList: {
      type: Function
    },
    // 是否支持他评
    isPeer: {
      type: Boolean,
      default: true
    },
    dataPermissionCode: {
      type: String,
      default: 'gwdt_addassessor_extent' /* 岗位地图-测评管理-人员管理选人 */
    },
    functionCode: {
      type: String,
      default: ''
    },
    supportSearchAll: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      list: [],
      keyword: '',
      pager: {
        pageSize: 20,
        offset: 0,
        total: 0
      },
      selectedIds: [...this.defaultSelection],
      selectedList: [...this.defaultRaw],
      drawerVisible: false,
      department: { id: '' },
      isSearchAll: false
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.drawerVisible = val;
        if (val) {
          this.search();
        } else {
          this.isSearchAll = false;
        }
      }
    },
    drawerVisible(val) {
      this.$emit('update:visible', val);
    },
    defaultRaw(val) {
      this.setSelectedList(val);
    }
  },
  methods: {
    async search(isAll = false) {
      this.pager.offset = 0;
      await this.getUserList(isAll);
    },
    async getUserList(isAll = false) {
      // 异步获取数据用Promise方法传值
      let processedPager = JSON.parse(JSON.stringify(this.pager));
      processedPager.pageSize = isAll ? 99999 : 20;
      const params = [this.department, this.keyword.trim(), processedPager];
      try {
        const res = await this.getList(...params);
        console.log(res);
        if (!isAll) {
          this.list = res.datas;
          this.pager.total = res.paging.count;
          this.setDefaultSelection();
        } else {
          // 全部筛选情况下赋值
          this.setSelectedList(res.datas);
          this.list.forEach(item => {
            if (item.selectable) {
              this.$refs.table.toggleRowSelection(item, true);
            }
          });
        }
      } catch (err) {
        // 同步的直接返回人员
        this.list = this.getList();
        console.log(this.list);
        this.setSelectedList(this.list);
        if (this.isSearchAll) {
          this.list.forEach(item => {
            if (item.selectable) {
              this.$refs.table.toggleRowSelection(item, true);
            }
          });
        } else {
          this.setDefaultSelection();
        }
      }
    },
    // getList (department, keyword, pager) {
    //     return new Promise((resolve, reject) => {
    //       GetEvalPositionUsers({
    //             deptIds: (department&&department.id) ? [department.id] : [],
    //             evalId: this.evalId,
    //             searchKey: keyword,
    //             planIds: [this.positionId]
    //           },{
    //             limit: (pager&&pager.pageSize) || 20,
    //             offset: (pager&&pager.offset) || 0
    //           }).then((res) => {
    //           res.datas.forEach((item) => {
    //             item.selectable = item.existEval !== 1
    //           })

    //           resolve(res)
    //         }).catch((e) => {
    //           reject(e)
    //         })
    //         // singularBaseUrl.post({
    //         //   url: 'talent/mgr/postmap/chooseuser',
    //         //   method: 'POST',
    //         //   data: {
    //         //     deptIds: department.id ? [department.id] : [],
    //         //     evalId: this.evalId,
    //         //     searchKey: keyword,
    //         //     planIds: [this.positionId]
    //         //   },
    //         //   params: {
    //         //     limit: pager.pageSize,
    //         //     offset: pager.offset
    //         //   }
    //         // }).then((res) => {
    //         //   res.datas.forEach((item) => {
    //         //     item.selectable = item.existEval !== 1
    //         //   })

    //         //   resolve(res)
    //         // }).catch((e) => {
    //         //   reject(e)
    //         // })
    //       })
    //     },

    // 全选
    searchAll() {
      this.isSearchAll = true;
      this.search(true);
    },
    setSelectedList(list = []) {
      let selectableList = [];
      if (this.isSearchAll) {
        selectableList = list.filter(item => item.selectable);
      } else {
        selectableList = this.defaultRaw;
      }
      this.selectedList = selectableList.map((item) => {
        return {
          fullName: item.fullName || item.fullname,
          userName: item.userName || item.username,
          userId: item.userId,
          modelId: item.modelId,
          modelName: item.modelName
        };
      });
    },
    cancel() {
      const isConfirm = this.selectedList.length !== this.defaultRaw.length;
      if (isConfirm) {
        this.$confirm(this.$t('pc_gwnl_jq_msg_currentOperationNotSavedCancel'), this.$t('pc_gwnl_jq_msg_sureCancel'), { type: 'warning' }).then(() => {
          this.$refs.table.clearSelection();
          this.drawerVisible = false;
        }).catch(() => { });
      } else {
        this.drawerVisible = false;
      }
    },

    // 确定
    submit() {
      this.$emit('selected', this.selectedList);
      this.drawerVisible = false;
    },
    beforeDrawClose(done) {
      const isConfirm = this.selectedList.length !== this.defaultRaw.length;
      done(isConfirm);
    },
    selectDept(data) {
      this.department = data;
      this.search();
    },
    // 处理默认选中
    setDefaultSelection() {
      this.$refs.table.clearSelection();
      const selected = this.list.filter(d => this.selectedList.some(s => s.userId === d.userId));
      if (!selected.length) return;
      selected.forEach(d => {
        this.$refs.table.toggleRowSelection(d);
      });
    },
    handleSelectionChange(val, row) {
      const selected = this.selectedList.find(d => d.userId === row.userId);
      // 有的话
      if (selected) { // 取消一条数据
        this.selectedList = this.selectedList.filter(d => d.userId !== row.userId);
      } else { // 增加一条数据
        this.selectedList.push(row);
      }
    },
    // 处理全选
    handleSelectAll(selection) {
      const ids = this.selectedList.map((item) => item.userId);
      if (selection.length) {
        selection.map((item) => {
          if (!ids.includes(item.userId)) {
            this.selectedList.push(item);
          }
        });
      } else {
        this.list.map((item) => {
          if (ids.includes(item.userId)) {
            this.selectedList = this.selectedList.filter(
              (item2) => item2.userId !== item.userId
            );
          }
        });
      }
    },
    // 删除已选择人员，并取消表格内选中
    handleSelectionClose(item) {
      this.selectedList = this.selectedList.filter(d => d.userId !== item.userId);
      const target = this.list.filter(d => d.userId === item.userId);
      if (target.length) {
        target.forEach(t => {
          this.$refs.table.toggleRowSelection(t, false);
        });
      }
    },
    // 清空所有
    clearAllSelection() {
      this.$refs.table.clearSelection();
      this.selectedList = [];
      this.selectedIds = [];
    }
  }
};
</script>
<style lang="scss">
.talent-select-thirdparty-user {
  .talent-select-thirdparty-user__left {
    padding-right: 24px;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .talent-select-thirdparty-user__right {
    padding-top: 24px;
    padding-left: 24px;
    border-left: 1px solid #e9e9e9;
    padding-bottom: 40px;
    width: 216px;
    flex-shrink: 0;
    box-sizing: border-box;
  }

  .yxt-drawer__body {
    padding-top: 0;
    padding-bottom: 0;
    display: flex;
    flex: 1;
  }

  .result-list__select-clear {
    position: absolute;
    bottom: 73px;
  }
  .result-list__selected{
    position: absolute;
    bottom: 73px;
    right: 40px;
  }

  .display-flex {
    display: flex;
  }
}
</style>
